// List GOR yang mendukung program ranked match
export const RANKED_MATCH_GOR_NAMES = [
  'GOR KONI',
  'GOR Rahayu Arena', 
  'GOR 150 Badminton',
  'GOR Badminkong',
  'GOR Masgun',
  'GOR PDAM'
];

// Fungsi helper untuk mengecek apakah GOR mendukung ranked match
export const hasRankedMatch = (gorName: string): boolean => {
  return RANKED_MATCH_GOR_NAMES.includes(gorName);
};

// Fungsi helper untuk mendapatkan badge text untuk GOR ranked match
export const getRankedMatchBadgeText = (): string => {
  return 'RANKED MATCH';
};
